export const TRANSLATE_SET_LOCALE = 'TRANSLATE_SET_LOCALE';

export const setLocale = (locale) => ({
  type: TRANSLATE_SET_LOCALE,
  payload: locale,
});
